import * as service from './service'
import Toast from 'antd-mobile/es/toast'

export default {
  namespace: 'equipmentMallOrderList',
  state: {
    orderData: []
  },
  effects: {
    * getOrderList ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getOrderList, payload)
        const { data } = res
        if (data.status === 200) {
          yield put({ type: 'save', payload: { orderData: data.data } })
          return data
        } else {
          Toast.info(data.err || '发生网络错误')
          return Promise.reject()
        }
      } catch (error) {
        Toast.info('发生网络错误')
      }
    },
    * applyRefund ({ payload }, { call, put }) {
      try {
        const res = yield call(service.applyRefund, payload)
        return res.data
      } catch (error) {
        Toast.info('发生网络错误')
      }
    },
    * confirmSign ({ payload }, { call, put }) {
      try {
        const res = yield call(service.confirmSign, payload)
        return res.data
      } catch (error) {
        Toast.info('发生网络错误')
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
